<template>
  <CustomModal id="open-licence-modal"
    class="basic-modal no-header-modal hide-cancel-btn"
    :hide-header="false"
    :title="$t('not_support_prime.title')"
    :isCloseButton="false"
    :ok-title="$t('common.confirmation')"
    @ok="$emit('ok')">
    <div>
      <div v-html="$t('not_support_prime.description')" />
    </div>
  </CustomModal>
</template>

<script>

  export default {
    name: 'licence-modal',
  };
</script>

<style lang="scss" scoped>
  .link {
    color: #00c896;
    cursor: pointer;
  }
</style>


// WEBPACK FOOTER //
// LicenceModal.vue?a6f5d74e